<template>
  <auth-split-layout v-if="ready">
    <component :is="form" />
  </auth-split-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthSplitLayout from '@/components/AuthSplitLayout.vue'
import CreateAccount from '@/views/CreateAccount.vue'
import LogIn from '@/views/LogIn.vue'
import { AUTH_PAGES_SWITCH } from '@/utils/authPages.js'

// One page for both /signup and /login (they share a view key in the router),
// so switching between them swaps only the form, not the layout and image.
export default {
  name: 'AuthPages',

  components: {
    AuthSplitLayout
  },

  data () {
    return {
      ready: false
    }
  },

  computed: {
    ...mapGetters({ isFeatureEnabled: 'waffle/isFeatureEnabled' }),

    form: function () {
      return this.$route.name === 'login' ? LogIn : CreateAccount
    }
  },

  async mounted () {
    // App fetches waffle on load, so only wait for it when the switch isn't
    // already known to be on.
    if (!this.isFeatureEnabled(AUTH_PAGES_SWITCH)) {
      await this.$store.dispatch('waffle/fetch')
    }
    if (!this.isFeatureEnabled(AUTH_PAGES_SWITCH)) {
      this.$router.replace({ name: 'not-found' })
      return
    }
    this.ready = true
  }
}
</script>
